module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'slbjn4i1',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
